import React, { useMemo, useEffect } from "react";
import { Label, FormFeedback, FormGroup } from "reactstrap";
import Select from "react-select/async";
import { getPersons } from "common/services/persons.service";
import { normalize } from "common/lib/normalize";
import {
  GroupBase,
  OptionsOrGroups,
} from "react-select/dist/declarations/src/types";

const SelectPerson = ({
  validation,
  selectedId,
  index,
  director,
}: {
  validation: any;
  isUpdate?: boolean;
  selectedId?: number;
  index: number;
  director: any;
}) => {
  const customSelectStyles = {
    control: (styles: any) => ({
      ...styles,
      borderColor:
        validation?.touched?.boardOfDirectors?.[index] &&
        validation?.errors?.boardOfDirectors?.[index]
          ? "red"
          : "#ced4da",
      "&:hover": {
        borderColor:
          validation?.touched?.boardOfDirectors?.[index] &&
          validation?.errors?.boardOfDirectors?.[index]
            ? "red"
            : "#ced4da",
      },
    }),
  };

  const [data, setData] = React.useState<any>([]);
  const [loading, setLoading] = React.useState<boolean>(false);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const response = await getPersons({
          pagination: {
            page: 1,
            pageSize: 20,
          },
        });
        setData(normalize(response.data));
      } catch (e) {
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [selectedId]);

  const options = useMemo(() => {
    return data.map((el: any) => {
      return {
        value: el?.id,
        label: `${el?.fullName || ""}`,
      };
    });
  }, [data]);

  return (
    <FormGroup key={index}>
      <Label
        htmlFor={`boardOfDirectors.${index}.person`}
        className="form-label"
      >
        Member/Person
      </Label>
      <Select
        name={`boardOfDirectors.${index}.person`}
        id={`boardOfDirectors.${index}.person`}
        value={
          validation.values.boardOfDirectors[index].person.value
            ? validation.values.boardOfDirectors[index].person
            : null
        }
        placeholder="Select person"
        onChange={(value: any) => {
          validation.setFieldValue(`boardOfDirectors.${index}.person`, value);
          validation.setFieldError(`boardOfDirectors.${index}.person`, "");
        }}
        defaultOptions={options}
        // @ts-ignore
        loadOptions={(
          inputValue: string,
          callback: (options: OptionsOrGroups<any, GroupBase<any>>) => void
        ) => {
          return getPersons({
            pagination: {
              page: 1,
              perPage: 20,
            },
            filters: {
              $or: [
                {
                  fullName: {
                    $containsi: inputValue,
                  },
                },
              ],
            },
          }).then((result: any) => {
            const parsedData = normalize(result.data);
            callback(
              parsedData.map((el: any) => {
                return {
                  value: el?.id,
                  label: `${el?.fullName || ""}`,
                };
              })
            );
          });
        }}
        onBlur={() =>
          validation.setFieldTouched(`boardOfDirectors.${index}.person`, true)
        }
        className={
          validation.touched.boardOfDirectors?.[index]?.person &&
          validation.errors.boardOfDirectors?.[index]?.person
            ? "is-invalid"
            : ""
        }
        styles={customSelectStyles}
        isLoading={loading}
      />
      <FormFeedback>
        {validation.errors.boardOfDirectors?.[index]?.person?.value}
      </FormFeedback>
    </FormGroup>
  );
};

export default SelectPerson;
